import { ResourceParam } from '~/types/navigation'

export const permissions = {
  nav: {
    subscription: {
      list: 'subscription_list:view',
      details: 'subscription_details:view',
      configuration: 'subscription_configuration:view',
      access: 'subscription_access:view',
      billing: 'subscription_billing:view',
    },
    partner: {
      list: 'partner_list:view',
      subscriptions: 'partner_subscriptions:view',
      details: 'partner_details:view',
      billing: 'partner_billing:view',
      team_members: 'partner_team_members:view',
      dealer_demo: 'partner_dealer_demo:view',
      access: 'partner_access:view',
    },
    customer: {
      list: 'customer_list:view',
      subscriptions: 'customer_subscriptions:view',
      details: 'customer_details:view',
    },
    billing: {
      list: 'billing_list:view',
    },
    settings: {
      information: 'settings_information:view',
      billing: 'settings_billing:view',
      team_members: 'settings_team_members:view',
      dealer_demo: 'settings_dealer_demo:view',
      user_management: 'settings_user_management:view',
      notification_banner: 'settings_technical_outage:view',
    },
    voucher: {
      list: 'voucher_list:view',
      claim: 'voucher:claim',
    },
    reseller: {
      list: 'reseller_list:view',
      subscriptions: 'reseller_subscriptions:view',
      details: 'reseller_details:view',
    },
    changelog: {
      list: 'changelog:view',
    },
    events: {
      list: 'events_list:view',
    },
    monitoring: {
      list: 'monitoring_list:view',
    },
  },
  subscription: {
    upgrade_printer_seats: 'subscription:upgrade_printer_seats',
    change: 'subscription:change',
    change_active: 'subscription:change_active',
    // change_auto_invoice: 'subscription:change_auto_invoice',
    edit: 'subscription:edit',
    edit_subscription_name: 'subscription:edit_subscription_name',
    extend_trial: 'subscription:extend_trial',
    override_printer_seats: 'subscription:override_printer_seats',
    edit_po_number: 'subscription:edit_po_number',
    cancel: 'subscription:cancel',
    cancel_options: 'subscription:cancel_options',
    max_printers: 'subscription:max_printers',
    create: 'subscription:create',
    apply_coupon: 'subscription:apply_coupon',
    // resend_invite_emails: 'subscription:resend_invite_emails',
    // add_invite_recipients: 'subscription:add_invite_recipients',

    salesforce_sync: 'subscription:salesforce_sync',
    view: {
      opportunity_id: 'subscription_opportunity_id:view',
    },
    access: {
      edit_instance: 'subscription:edit_instance',
      send_invite: 'subscription:send_instance_invite',
    },
    notes: {
      add: 'subscription_notes:add',
      edit: 'subscription_notes:edit',
    },
    instance_name: 'subscription_instance_name:view',
  },
  settings: {
    billing: {
      // edit: 'settings_billing:edit',
    },
  },
  billing: {
    // download: 'billing:download',
    edit_po_number: 'billing:edit_po_number',
  },
  activity_log: {
    view: 'activity_log:view',
  },
  voucher: {
    claim: 'voucher:claim',
    // share: 'voucher:share',
  },
  reseller: {
    // edit: 'reseller:edit',
  },
  partner: {
    add: 'partner:add',
    merge: 'partner:merge',
    edit: {
      details: 'partner:edit',
      contract: 'partner_contract:edit',
      tier: 'partner_tier:edit',
      term: 'partner_term:edit',
      all: 'partner:edit_all',
    },
    view: {
      status: 'partner:view_status',
      server_location: 'partner:view_server_location',
    },
    // resend_invite: 'partner:resend_invite',
    delete: 'partner:delete',
    billing: {
      edit: 'partner_billing:edit',
    },
    team_members: {
      add: 'partner_team_members:add',
      edit: 'partner_team_members:edit',
      delete: 'partner_team_members:delete',
      // resend: 'partner_team_members:resend',
      impersonate: 'partner_team_members:impersonate',
    },
    dealer_demo: {
      create: 'partner_dealer_demo:create',
      invite: 'partner_dealer_demo:invite',
    },
  },
  customer: {
    edit: 'customer:edit',
  },
}

export const routePermissions: { [key: string]: string[] } = {
  'subscription-portal-subscriptions': [permissions.nav.subscription.list],
  'subscription-portal-subscriptions-new': [permissions.subscription.create],
  'subscription-portal-customers-customerId-subscriptions-subId-overview': [
    permissions.nav.subscription.details,
  ],
  'subscription-portal-customers-customerId-subscriptions-subId-configuration':
    [permissions.nav.subscription.configuration],
  'subscription-portal-customers-customerId-subscriptions-subId-access': [
    permissions.nav.subscription.access,
  ],
  'subscription-portal-customers-customerId-subscriptions-subId-billing': [
    permissions.nav.subscription.billing,
  ],
  'subscription-portal-customers-customerId-subscriptions-subId-activity-log': [
    permissions.activity_log.view,
  ],
  'subscription-portal-customers-customerId-subscriptions-subId-upgrade-printer-seats':
    [permissions.subscription.upgrade_printer_seats],
  'subscription-portal-customers-customerId-subscriptions-subId-change-subscription':
    [permissions.subscription.change, permissions.subscription.change_active],

  'subscription-portal-partners': [permissions.nav.partner.list],
  'subscription-portal-partners-new': [permissions.partner.add],
  'subscription-portal-partners-partnerId-subscriptions': [
    permissions.nav.partner.subscriptions,
  ],
  'subscription-portal-partners-partnerId-information': [
    permissions.nav.partner.details,
  ],
  'subscription-portal-partners-partnerId-billing': [
    permissions.nav.partner.billing,
  ],
  'subscription-portal-partners-partnerId-team-members': [
    permissions.nav.partner.team_members,
  ],
  'subscription-portal-partners-partnerId-demo': [
    permissions.nav.partner.dealer_demo,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-overview': [
    permissions.nav.partner.subscriptions,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-configuration': [
    permissions.nav.partner.details,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-access': [
    permissions.nav.partner.access,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-billing': [
    permissions.nav.partner.billing,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-activity-log': [
    permissions.activity_log.view,
  ],
  'subscription-portal-partners-partnerId-subscriptions-subId-upgrade-printer-seats':
    [permissions.subscription.upgrade_printer_seats],
  'subscription-portal-partners-partnerId-subscriptions-subId-change-subscription':
    [permissions.subscription.change, permissions.subscription.change_active],

  'subscription-portal-customers': [permissions.nav.customer.list],
  'subscription-portal-customers-customerId-subscriptions': [
    permissions.nav.customer.subscriptions,
  ],
  'subscription-portal-customers-customerId-company-information': [
    permissions.nav.customer.details,
  ],

  'subscription-portal-billing': [permissions.nav.billing.list],
  'subscription-portal-billing-invoices': [permissions.nav.billing.list],
  'subscription-portal-billing-credit-notes': [permissions.nav.billing.list],

  'subscription-portal-vouchers': [permissions.nav.voucher.list],
  'subscription-portal-claim': [permissions.nav.voucher.claim],

  'subscription-portal-resellers': [permissions.nav.reseller.list],
  'subscription-portal-resellers-resellerId-subscriptions': [
    permissions.nav.reseller.subscriptions,
  ],
  'subscription-portal-resellers-resellerId-company-information': [
    permissions.nav.reseller.details,
  ],
  'subscription-portal-resellers-resellerId-subscriptions-subId-overview': [
    permissions.nav.reseller.subscriptions,
  ],
  'subscription-portal-resellers-resellerId-subscriptions-subId-configuration':
    [permissions.nav.reseller.subscriptions],
  'subscription-portal-resellers-resellerId-subscriptions-subId-access': [
    permissions.nav.reseller.subscriptions,
  ],
  'subscription-portal-resellers-resellerId-subscriptions-subId-billing': [
    permissions.nav.reseller.subscriptions,
  ],
  'subscription-portal-resellers-resellerId-subscriptions-subId-activity-log': [
    permissions.activity_log.view,
  ],
  'subscription-portal-resellers-resellerId-subscriptions-subId-upgrade-printer-seats':
    [permissions.subscription.upgrade_printer_seats],
  'subscription-portal-resellers-resellerId-subscriptions-subId-change-subscription':
    [permissions.subscription.change, permissions.subscription.change_active],

  'subscription-portal-settings-information': [
    permissions.nav.settings.information,
  ],
  'subscription-portal-settings-admin-user-management': [
    permissions.nav.settings.user_management,
  ],
  'subscription-portal-settings-admin-notification-banner': [
    permissions.nav.settings.notification_banner,
  ],
  'subscription-portal-settings-billing': [permissions.nav.settings.billing],
  'subscription-portal-settings-team-members': [
    permissions.nav.settings.team_members,
  ],
  'subscription-portal-settings-demo': [permissions.nav.settings.dealer_demo],

  'subscription-portal-changelog': [permissions.nav.changelog.list],

  'subscription-portal-events': [permissions.nav.events.list],
  'subscription-portal-events-eventId-overview': [permissions.nav.events.list],

  'subscription-portal-monitoring-provisioning-status': [
    permissions.nav.monitoring.list,
  ],
  'subscription-portal-monitoring-server-uptime': [
    permissions.nav.monitoring.list,
  ],
  'subscription-portal-monitoring-incidents': [permissions.nav.monitoring.list],
}

export const RESOURCE_PARAMS: ResourceParam[] = [
  'subId',
  'partnerId',
  'resellerId',
  'customerId',
  'eventId',
]
